export const FALLBACK_TIMEZONE_ID = 'Europe/Copenhagen';
